import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateJun = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / June`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#D1D7B3)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#D1D7B3)",
								stroke: "var(--sticker-dark,#5F6F27)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7383
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.387 12.9922 C9.8217 12.9921 9.3603 12.8321 9.0031 12.5122 C8.6511 12.1868 8.475 11.7201 8.475 11.1121 L9.723 11.1122 C9.7337 11.3575 9.7924 11.5469 9.899 11.6801 C10.0057 11.8081 10.1577 11.8721 10.355 11.8721 C10.5417 11.8722 10.683 11.8135 10.7791 11.6961 C10.8804 11.5735 10.931 11.4055 10.931 11.1921 L10.931 7.2962 L12.1871 7.2961 L12.1871 11.1922 C12.1871 11.7735 12.0244 12.2188 11.699 12.5281 C11.3737 12.8375 10.9364 12.9921 10.387 12.9922 Z M15.127 12.9921 C14.6042 12.9921 14.1749 12.8882 13.8389 12.6802 C13.5029 12.4722 13.255 12.1948 13.0949 11.8481 C12.9349 11.5014 12.8549 11.1175 12.855 10.6961 L12.8549 7.2961 L14.1109 7.2961 L14.1109 10.7041 C14.1109 11.0668 14.1989 11.3468 14.3749 11.5442 C14.5509 11.7362 14.8096 11.8322 15.1509 11.8322 C15.4869 11.8321 15.7456 11.7362 15.9269 11.5442 C16.1136 11.3468 16.2069 11.0668 16.2069 10.7041 L16.2069 7.2962 L17.4629 7.2961 L17.4629 10.6962 C17.463 11.1335 17.3909 11.4988 17.2469 11.7921 C17.1029 12.0854 16.9136 12.3202 16.6789 12.4961 C16.4496 12.6721 16.1963 12.8002 15.9189 12.8802 C15.6469 12.9548 15.3829 12.9921 15.127 12.9921 Z M18.1034 12.8961 L18.1034 7.2961 L19.3675 7.2961 L21.7594 10.8242 L21.7594 7.2961 L23.0234 7.2961 L23.0234 12.8962 L21.7594 12.8962 L19.3674 9.3841 L19.3674 12.8961 L18.1034 12.8961 Z",
							id: `${__svgrId}-JUN`,
							style: { fill: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.1461",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateJun;
